import { render } from "./chat-side-menu-item.vue?vue&type=template&id=0fdae23c"
import script from "./chat-side-menu-item.vue?vue&type=script&lang=js"
export * from "./chat-side-menu-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__